const getDefaultState = () => {
  return {
    optionsPersonType: [],
    optionsIdentificationType: [],
    optionsCountries: [],
    optionsCountriesAbrevs: [],
    optionsDepartments: [],
    optionsCity: [],
    optionsGender: [],
    optionsChannel: [],
    optionsProducts: [],
    optionsReasons: [],
    optionsControlEntity: [],
    optionsConditions: [],
    optionsStates: [],
    optionsCompanies: [],
    optionsCriterions: [],
    optionsGroupCompany: [],
    optionsPosition: [],
    optionsCompanyType: [],
    optionsDirections: [],
    optionsReception: [],
    optionsFraudTypes: [],
    optionsFraudModes: [],
    optionsDuplicityStates: [],
    optionsStatesSolip: [],
    optionsStatesAnnexesSolip: [],
    optionsTypeAnalisis: [],
    optionsTypeMlValidation: [],
    optionsTypeRequestSolip: [],
    optionsTypeProblem: [],
    optionsStateTechnicalSupport: [],
    optionsAllCompanies: [],
    optionsRadicatorProfile: [],
    optionsCompanyEmisor: [],
    optionsEntityType: [],
    optionsMannedCheckpoint: [],
    optionsReasonsEmisor: [],
    optionsStatesEmisor: [],
    optionsTypeValueEmisor: [],
    optionsLgbtiq: [],
  };
};

const state = getDefaultState;

const mutations = {
  setFormOptions(state, payload) {
    state.optionsPersonType = payload.optionsPersonType;
    state.optionsIdentificationType = payload.optionsIdentificationType;
    state.optionsTypeProblem = payload.optionsTypeProblem;
    state.optionsStateTechnicalSupport = payload.optionsStateTechnicalSupport;
    state.optionsCountries = payload.optionsCountries;
    state.optionsCountriesAbrevs = payload.optionsCountriesAbrevs;
    state.optionsDepartments = payload.optionsDepartments;
    state.optionsCity = payload.optionsCity;
    state.optionsAllCompanies = payload.optionsAllCompanies;
    state.optionsRadicatorProfile = payload.optionsRadicatorProfile;
  },
  setComplaintOptions(state, payload) {
    state[Object.keys(payload)[0]] = Object.values(payload)[0];
  },
  setDashboardOptions(state, payload) {
    state.optionsCriterions = payload.optionsCriterions;
    state.optionsPosition = payload.optionsPosition;
    state.optionsGroupCompany = payload.optionsGroupCompany;
    state.optionsCompanyType = payload.optionsCompanyType;
    state.optionsDirections = payload.optionsDirections;
    state.optionsReception = payload.optionsReception;
    state.optionsFraudTypes = payload.optionsFraudTypes;
    state.optionsFraudModes = payload.optionsFraudModes;
    state.optionsRadicatorProfile = payload.optionsRadicatorProfile;
    state.optionsCompanyEmisor = payload.optionsCompanyEmisor;
    state.optionsEntityType = payload.optionsEntityType;
    state.optionsMannedCheckpoint = payload.optionsMannedCheckpoint;
    state.optionsReasonsEmisor = payload.optionsReasonsEmisor;
    state.optionsStatesEmisor = payload.optionsStatesEmisor;
    state.optionsTypeValueEmisor = payload.optionsTypeValueEmisor;
    state.optionsLgbtiq = payload.optionsLgbtiq;
  },
  setListOptions(state, payload) {
    state[payload.listName] = payload.listData;
  },
};
const actions = {
  // Load all form options for USER REGISTRATION
  loadFormOptions({ commit, dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let countries = dispatch("loadOptions", { url: baseUrl + "/api/country/" });
    let countriesAbrevs = dispatch("loadOptions", {
      url: baseUrl + "/api/countryabrevs/",
    });
    let optionsTypeProblem = dispatch("loadOptions", {
      url: baseUrl + "/api/type-problem-choices/",
    });
    let optionsStateTechnicalSupport = dispatch("loadOptions", {
      url: baseUrl + "/api/support-state/",
    });
    let identificationType = dispatch("loadOptions", {
      url: baseUrl + "/api/identificationtype/",
    });
    let personType = dispatch("loadOptions", {
      url: baseUrl + "/api/persontype/",
    });
    let departments = dispatch("loadOptions", {
      url: baseUrl + "/api/department/",
    });
    let optionsAllCompanies = dispatch("loadOptions", {
      url: baseUrl + "/api/company_list/",
    });
    let optionsRadicatorProfile = dispatch("loadOptions", {
      url: baseUrl + "/api/radicatorprofile_options/",
    });

    Promise.all([
      personType,
      identificationType,
      countries,
      departments,
      countriesAbrevs,
      optionsTypeProblem,
      optionsStateTechnicalSupport,
      optionsAllCompanies,
      optionsRadicatorProfile,
    ])
      .then((response) => {
        let optionsPersonType = response[0];
        let optionsIdentificationType = response[1].filter((identification) => {
          if (identification.name != "NIT") {
            return identification;
          }
        });
        let optionsCountries = response[2].map((item) => {
          return {
            ...item,
            id: item.code,
          };
        });
        let optionsDepartments = response[3].map((item) => {
          return {
            ...item,
            id: item.code,
          };
        });

        let optionsCountriesAbrevs = response[4].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsTypeProblem = response[5].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        let optionsStateTechnicalSupport = response[6].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsAllCompanies = response[7].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });
        let optionsRadicatorProfile = response[8].map((item) => {
          return {
            ...item,
            id: item.id,
          };
        });

        commit("setFormOptions", {
          optionsPersonType,
          optionsIdentificationType,
          optionsCountries,
          optionsDepartments,
          optionsCountriesAbrevs,
          optionsTypeProblem,
          optionsStateTechnicalSupport,
          optionsAllCompanies,
          optionsRadicatorProfile,
        });
      })
      .catch((e) => console.error(e));
  },
  // Load all form options for COMPLAINTS registration with TOKEN
  loadComplaintOptions({ commit, dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let companies = dispatch("loadOptions", {
      url: baseUrl + "/api/company/",
      auth: true,
    });
    let channel = dispatch("loadOptions", {
      url: baseUrl + "/api/channel/",
      auth: true,
    });
    let states = dispatch("loadOptions", {
      url: baseUrl + "/api/state/",
      auth: true,
    });
    let gender = dispatch("loadOptions", {
      url: baseUrl + "/api/gender/",
      auth: true,
    }); /*
    let duplicityStates = dispatch("loadOptions", {
      url: baseUrl + "/api/duplicity/",
      auth: true,
    });*/
    let product = dispatch("loadOptions", {
      url: baseUrl + "/api/product/",
      auth: true,
    });
    let reason = dispatch("loadOptions", {
      url: baseUrl + "/api/reason/",
      auth: true,
    });
    let controlEntity = dispatch("loadOptions", {
      url: baseUrl + "/api/controlentity/",
      auth: true,
    });
    let conditions = dispatch("loadOptions", {
      url: baseUrl + "/api/condition/",
      auth: true,
    });
    let optionsTypeAnalisis = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/analysis-types",
      auth: true,
    });
    let optionsTypeMlValidation = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/mlvalidate-types",
      auth: true,
    });
    let optionsStatesSolip = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/solicitude-status",
      auth: true,
    });
    let optionsStatesAnnexesSolip = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/annexes-status",
      auth: true,
    });
    let optionsTypeRequestSolip = dispatch("loadOptions", {
      url: baseUrl + "/api/jurisdiccional-servi/solicitude-types",
      auth: true,
    });
    let optionsAllCompanies = dispatch("loadOptions", {
      url: baseUrl + "/api/company_list/",
      auth: true,
    });
    let radicatorProfiles = dispatch("loadOptions", {
      url: baseUrl + "/api/radicatorprofile_options/",
      auth: true,
    });
    let companyEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisores/",
      auth: true,
    });
    let entityType = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorestype/",
      auth: true,
    });
    let mannedCheckpoint = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorescontrol/",
      auth: true,
    });
    let reasonsEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores/",
      auth: true,
    });
    let statesEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/state-emisores/",
      auth: true,
    });
    let typeValueEmisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores-value/",
      auth: true,
    });
    let options_lgbtiq = dispatch("loadOptions", {
      url: baseUrl + "/api/lgbtiq-choices/",
      auth: true,
    });
    channel.then((value) => {
      const optionsChannel = value;
      commit("setComplaintOptions", { optionsChannel });
    });
    states.then((value) => {
      const optionsStates = value;
      commit("setComplaintOptions", { optionsStates });
    });
    gender.then((value) => {
      const optionsGender = value;
      commit("setComplaintOptions", { optionsGender });
    }); /*
    duplicityStates.then((value) => {
      const optionsDuplicityStates = value;
      commit("setComplaintOptions", { optionsDuplicityStates });
    });*/
    product.then((value) => {
      const optionsProducts = value;
      commit("setComplaintOptions", { optionsProducts });
    });
    reason.then((value) => {
      const optionsReasons = value;
      commit("setComplaintOptions", { optionsReasons });
    });
    controlEntity.then((value) => {
      const optionsControlEntity = value;
      commit("setComplaintOptions", { optionsControlEntity });
    });
    conditions.then((value) => {
      const optionsConditions = value;
      commit("setComplaintOptions", { optionsConditions });
    });
    companies.then((value) => {
      const optionsCompanies = value;
      commit("setComplaintOptions", { optionsCompanies });
    });
    optionsTypeAnalisis.then((value) => {
      const optionTypeAnalisis = value;
      commit("setComplaintOptions", { optionTypeAnalisis });
    });
    optionsTypeMlValidation.then((value) => {
      const optionTypeMlValidation = value;
      commit("setComplaintOptions", { optionTypeMlValidation });
    });
    optionsStatesSolip.then((value) => {
      let transformedArray = value.map((item) => ({
        id: item.status,
        name: item.status,
      }));
      commit("setComplaintOptions", { optionsStatesSolip: transformedArray });
    });
    optionsStatesAnnexesSolip.then((value) => {
      let transformedArray = value.map((item) => ({
        id: item.status,
        name: item.status,
      }));
      commit("setComplaintOptions", {
        optionsStatesAnnexesSolip: transformedArray,
      });
    });
    optionsTypeRequestSolip.then((value) => {
      let transformedArray = value.map((item) => ({
        id: item.bigquery_field,
        name: item.name,
      }));
      commit("setComplaintOptions", {
        optionsTypeRequestSolip: transformedArray,
      });
    });
    optionsAllCompanies.then((value) => {
      const optionAllCompanies = value;
      commit("setComplaintOptions", { optionAllCompanies });
    });
    radicatorProfiles.then((value) => {
      const optionsRadicatorProfile = value;
      commit("setComplaintOptions", { optionsRadicatorProfile });
    });
    companyEmisor.then((value) => {
      const optionsCompanyEmisor = value;
      commit("setComplaintOptions", { optionsCompanyEmisor });
    });
    entityType.then((value) => {
      const optionsEntityType = value;
      commit("setComplaintOptions", { optionsEntityType });
    });
    mannedCheckpoint.then((value) => {
      const optionsMannedCheckpoint = value;
      commit("setComplaintOptions", { optionsMannedCheckpoint });
    });
    reasonsEmisor.then((value) => {
      const optionsReasonsEmisor = value;
      commit("setComplaintOptions", { optionsReasonsEmisor });
    });
    statesEmisor.then((value) => {
      const optionsStatesEmisor = value;
      commit("setComplaintOptions", { optionsStatesEmisor });
    });
    typeValueEmisor.then((value) => {
      const optionsTypeValueEmisor = value;
      commit("setComplaintOptions", { optionsTypeValueEmisor });
    });
    options_lgbtiq.then((value) => {
      const optionsLgbtiq = value;
      commit("setComplaintOptions", { optionsLgbtiq });
    });
  },
  // Load all form options for DASHBOARD registration with TOKEN
  loadDashboardOptions({ commit, dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let criterions = dispatch("loadOptions", {
      url: baseUrl + "/api/criterion/",
      auth: true,
    });
    let positions = dispatch("loadOptions", {
      url: baseUrl + "/api/position/",
      auth: true,
    });
    let groupCompany = dispatch("loadOptions", {
      url: baseUrl + "/api/group/",
      auth: true,
    });
    let companyType = dispatch("loadOptions", {
      url: baseUrl + "/api/companytype/",
      auth: true,
    });
    let directions = dispatch("loadOptions", {
      url: baseUrl + `/api/direction/`,
      auth: true,
    });
    let reception = dispatch("loadOptions", {
      url: baseUrl + `/api/instance/`,
      auth: true,
    });
    let fraud_types = dispatch("loadOptions", {
      url: baseUrl + `/api/fraud_types/`,
      auth: true,
    });
    let fraud_modes = dispatch("loadOptions", {
      url: baseUrl + `/api/fraud_modes/`,
      auth: true,
    });
    let radicator_profiles = dispatch("loadOptions", {
      url: baseUrl + `/api/radicatorprofile_options/`,
      auth: true,
    });
    let company_emisor = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisores/",
    });
    let entity_type = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorestype/",
    });
    let manned_checkpoint = dispatch("loadOptions", {
      url: baseUrl + "/api/companyemisorescontrol/",
    });
    let reasons_emisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores/",
    });
    let states_emisor = dispatch("loadOptions", {
      url: baseUrl + "/api/state-emisores/",
    });
    let type_value_emisor = dispatch("loadOptions", {
      url: baseUrl + "/api/reasons-emisores-value/",
    });
    let options_lgbtiq = dispatch("loadOptions", {
      url: baseUrl + "/api/lgbtiq-choices/",
      auth: true,
    });

    Promise.allSettled([
      criterions,
      positions,
      groupCompany,
      companyType,
      directions,
      reception,
      fraud_types,
      fraud_modes,
      radicator_profiles,
      company_emisor,
      entity_type,
      manned_checkpoint,
      reasons_emisor,
      states_emisor,
      type_value_emisor,
      options_lgbtiq,
    ])
      .then((response) => {
        let optionsCriterions = response[0].value;
        let optionsPosition = response[1].value;
        let optionsGroupCompany = response[2].value;
        let optionsCompanyType = response[3].value;
        let optionsDirections = response[4].value;
        let optionsReception = response[5].value;
        let optionsFraudTypes = response[6].value;
        let optionsFraudModes = response[7].value;
        let optionsRadicatorProfile = response[8].value;
        let optionsCompanyEmisor = response[9].value;
        let optionsEntityType = response[10].value;
        let optionsMannedCheckpoint = response[11].value;
        let optionsReasonsEmisor = response[12].value;
        let optionsStatesEmisor = response[13].value;
        let optionsTypeValueEmisor = response[14].value;
        let optionsLgbtiq = response[15].value;

        commit("setDashboardOptions", {
          optionsCriterions,
          optionsPosition,
          optionsGroupCompany,
          optionsCompanyType,
          optionsDirections,
          optionsReception,
          optionsFraudTypes,
          optionsFraudModes,
          optionsRadicatorProfile,
          optionsCompanyEmisor,
          optionsEntityType,
          optionsMannedCheckpoint,
          optionsReasonsEmisor,
          optionsStatesEmisor,
          optionsTypeValueEmisor,
          optionsLgbtiq,
        });
      })
      .catch((error) => console.error(error.response));
  },

  loadAllCompaniesOptions({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/company_list/`;
    let allCompanies = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return allCompanies.then((response) => {
      return response;
    });
  },

  // Load municipalities options by id department
  async loadMunicipalitiesOptions({ dispatch }, payload) {
    if (payload.department == null || payload.department == undefined) return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/municipality/?department=${payload.department}`;
    let municipalities = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return municipalities.then((response) => {
      let optionsMunicipalities = response.map((item) => {
        return {
          ...item,
          id: item.code,
        };
      });
      return optionsMunicipalities;
    });
  },
  // Load reasons options by id company
  loadReasonsOptions({ dispatch }, payload) {
    if (payload.company == null || payload.company == undefined) return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reason/company/?id_company=${payload.company}`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },

  // Load All reasons emisores
  loadAllReasonsEmisorOptions({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reasons-emisores/`;
    let reasonsEmisor = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return reasonsEmisor.then((response) => {
      return response;
    });
  },
  // Load reasons options by type value
  loadReasonsEmisorOptions({ dispatch }, payload) {
    if (
      payload.type_value_emisor == null ||
      payload.type_value_emisor == undefined
    )
      return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reasons-emisores/?tipo_valor_id=${payload.type_value_emisor}`;
    let reasonsEmisor = dispatch("loadOptions", {
      url: baseUrl + url,
      auth: true,
    });
    return reasonsEmisor.then((response) => {
      return response;
    });
  },

  loadReasonsOpt({ dispatch }) {
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/reason/`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },

  // Load products options by id company
  loadProductsOptions({ dispatch }, payload) {
    if (payload.company == null || payload.company == undefined) return;

    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/product/company/?id_company=${payload.company}`;
    let reasons = dispatch("loadOptions", { url: baseUrl + url, auth: true });
    return reasons.then((response) => {
      return response;
    });
  },
  // Load options with pagination
  async loadOptions(context, payload) {
    try {
      // ToDo: Reevaluar si está lógica es necesaria para el funcionamiento general
      let values = [];
      while (payload.url) {
        let url = payload.url;
        url = "/api" + url.split("/api")[1];
        const response = await this._vm.$apiBase(url);
        const { results, next } = response.data;
        values.push(...results);
        payload.url = next;
      }
      return values;
    } catch (e) {
      console.error(e);
      return [];
    }
  },
  loadListOptions({ commit, dispatch }, payload) {
    if (payload == null || payload == undefined) return;
    let baseUrl = this._vm.$apiBase.defaults.baseURL;
    let url = `/api/${payload.endpoint}`;
    dispatch("loadOptions", { url: baseUrl + url, auth: true }).then(
      (response) => {
        commit("setListOptions", {
          listName: payload.name,
          listData: response,
        });
      },
    );
  },
};

const form = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default form;
